import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {Config, ConfigsQueryResponse, ResponseConfig} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const CONFIG_URL = `${API_URL}/api/config`
const GET_CONFIGS_URL = `${API_URL}/api/config`

const getConfigs = (): Promise<ConfigsQueryResponse> => {
  return axios.get(GET_CONFIGS_URL).then((d: AxiosResponse<ConfigsQueryResponse>) => d.data)
}

const getConfigById = (id: ID): Promise<ResponseConfig> =>
  axios.get(`${CONFIG_URL}/${id}`).then((response: AxiosResponse<ResponseConfig>) => response.data)

const createConfig = (config: Config): Promise<ResponseConfig> => {
  return axios
    .post(CONFIG_URL, config)
    .then((response: AxiosResponse<ResponseConfig>) => response.data)
}

const updateConfig = (config: Config): Promise<ResponseConfig> => {
  return axios
    .put(`${CONFIG_URL}/${config.id}`, config)
    .then((response: AxiosResponse<ResponseConfig>) => response.data)
}

const deleteConfig = (configId: ID): Promise<void> => {
  return axios.delete(`${CONFIG_URL}/${configId}/excluir`).then(() => {})
}

const deleteSelectedConfigs = (configIds: Array<ID>): Promise<void> => {
  const requests = configIds.map((id, index) => axios.delete(`${CONFIG_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getConfigs, deleteConfig, deleteSelectedConfigs, getConfigById, createConfig, updateConfig}
